import { useEffect } from "react";

// Site-wide WebSite + Organization entity graph for Azeka Global.
const GRAPH = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "@id": "https://azekaglobal.com/#website",
      name: "Azeka Global",
      alternateName: "Azeka",
      url: "https://azekaglobal.com",
      publisher: { "@id": "https://azekaglobal.com/#organization" },
    },
    {
      "@type": "Organization",
      "@id": "https://azekaglobal.com/#organization",
      legalName: "AZEKA GLOBAL TRADE FZCO",
      name: "Azeka Global",
      url: "https://azekaglobal.com",
      logo: "https://azekaglobal.com/azeka-global-navy.png",
      email: "info@azekaglobal.com",
      address: { "@type": "PostalAddress", addressLocality: "Dubai", addressCountry: "AE" },
    },
  ],
};

export function SiteStructuredData() {
  useEffect(() => {
    let s = document.getElementById("ld-site");
    if (!s) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "ld-site";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(GRAPH);
  }, []);
  return null;
}
